import React, {useState} from "react";
import NoDataContent from "../../../../../../components/reports/report-menu/no-data-content.jsx";
import reportUtils from "../../../../../../utils/report-utils.js";

const INITIAL_LIMIT = 15;
const OccByNeighborhoodAndPeriod = ({data, reportInfo}) => {
  const [limit, setLimit] = useState(INITIAL_LIMIT);
  const seeMoreOrLess = () => {
    setLimit(prev => prev ? null : INITIAL_LIMIT);
  };

  return(
    <>
      <div className="chart-report">
        <span className="chart-title">{reportInfo.reportName} {(data.length > limit && limit) ? ' (TOP 15)' : ''}</span>
      </div>
      {
        data.length > 0
          ?<div className="mt-3">
            <table id={reportInfo.reportId} className="table report-table" sheet-name={reportInfo.reportName}>
              <thead className="thead-background print:table-row-group!">
              <tr className="bg-[#f6f6f6] text-left">
                <th className="w-[70%]">Bairro</th>
                <th className="w-[9%] text-center">Madrugada</th>
                <th className="w-[6%] text-center">Manhã</th>
                <th className="w-[5%] text-center">Tarde</th>
                <th className="w-[5%] text-center">Noite</th>
                <th className="w-[5%] text-center">Total</th>
              </tr>
              </thead>
              <tbody>
              {(!!limit ? data.slice(0, limit) : data).map((el, index) => (
                <React.Fragment key={index}>
                  <tr className={`table-break-word`}>
                    <td>{reportUtils.formatText(el.neighborhood)}</td>
                    <td className="text-center">{el.dawn}</td>
                    <td className="text-center">{el.morning}</td>
                    <td className="text-center">{el.afternoon}</td>
                    <td className="text-center">{el.night}</td>
                    <td className="text-center">{el.total}</td>
                  </tr>
                </React.Fragment>
              ))}
              </tbody>
            </table>
            { data.length > INITIAL_LIMIT &&
              <div className="w-full flex justify-end gap-2 print-hide">
              <span className="see-more print-hide" onClick={seeMoreOrLess}>
                { limit ? "Ver mais" : "Ver menos"}
              </span>
              </div>
            }
          </div>
          : <div className="mt-1"><NoDataContent reportData={true} data={0}/></div>
      }
      <div className="chart-divisor"></div>
    </>
  )
}

export default OccByNeighborhoodAndPeriod;
